import { DateTime } from '@ksyos/date-time';
import { getDisplayName } from '@common/utils/getDisplayName';
import type { IPatient } from '../../../../common/interfaces/patient';
import type { IHolterDesktopProcess } from '../../interfaces/holterDesktopProcess';
import { HolterInformation } from './HolterInformation';

export function PatientInformation(
    props: Readonly<{
        configurationDatetime?: string;
        patient: IPatient | null;
        procedureType?: string;
        processDesktopData?: IHolterDesktopProcess['data'];
    }>
) {
    const { configurationDatetime, patient, procedureType, processDesktopData } = props;
    if (!processDesktopData) {
        return null;
    }

    if (!patient) {
        if (processDesktopData.holterPresent === true && processDesktopData.recordingsAvailable === true) {
            return (
                <HolterInformation
                    batteryChargePercentage={processDesktopData.batteryChargePercentage}
                    firmwareVersion={processDesktopData.firmwareVersion}
                    recorderId={processDesktopData.holterSerialNumber}
                />
            );
        } else {
            return null;
        }
    }

    return (
        <HolterInformation
            batteryChargePercentage={processDesktopData.batteryChargePercentage}
            birthDate={patient.birthDate && DateTime.from(patient.birthDate).format('YYYY-MM-DD')}
            configurationDatetime={configurationDatetime}
            firmwareVersion={processDesktopData.firmwareVersion}
            gender={patient.gender}
            patientName={getDisplayName(patient)}
            procedureType={procedureType}
            recorderId={processDesktopData.holterSerialNumber}
        />
    );
}
